import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    template
})
export default class {
    constructor ($translate, lodash, ListFactory, ModalService, MetaFieldGroupResource, MetaFieldResource, DATATABLES, FORMS_META_FIELD_TYPE_ENUM,
                 TokenService, QuestionService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.MetaFieldResource = MetaFieldResource;
        this.MetaFieldGroupResource = MetaFieldGroupResource;
        this.ListFactory = ListFactory;
        this.ModalService = ModalService;
        this.QuestionService = QuestionService;

        this.DATATABLES = DATATABLES;
        this.FORMS_META_FIELD_TYPE_ENUM = FORMS_META_FIELD_TYPE_ENUM;

        this.list = ListFactory.createWithPagination(MetaFieldGroupResource.query.bind(MetaFieldGroupResource));
        this.list.fetch({ expand: 'activeI18n,metaGroupI18ns' }).then(() => {
            this.openAll();
        });
        this.metaFieldLists = [];
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.activeLanguage = TokenService.getActiveLanguage();
        this.errors = [];
    }

    getMetaFieldValues (metaField) {
        const metaFieldValuesI18ns = this.lodash.reduce(metaField.metaFieldValuesI18ns, (origin, item) => {
            if (!origin[item.language]) {
                origin[item.language] = [];
            }
            origin[item.language].push(item);
            return origin;
        }, {});
        return metaFieldValuesI18ns[this.activeLanguage]
            ? metaFieldValuesI18ns[this.activeLanguage].map(item => item.value).join(', ')
            : metaFieldValuesI18ns[this.defaultLanguage].map(item => item.value).join(', ');
    }

    populateMetaFields (index, groupId) {
        if (!this.opened[index]) {
            this.metaFieldLists[index] = this.ListFactory.createWithPagination(this.MetaFieldResource.query.bind(this.MetaFieldResource));
            this.metaFieldLists[index].fetch({ metaFieldGroupId: groupId, expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns' });
        }
        this.opened[index] = !this.opened[index];
    }

    openAll () {
        let index = 0;
        this.opened = this.lodash.reduce(this.list.items, (result, metaGroup) => {
            result.push(true);
            if (!this.metaFieldLists[index]) {
                this.metaFieldLists[index] = this.ListFactory.createWithPagination(this.MetaFieldResource.query.bind(this.MetaFieldResource));
                this.metaFieldLists[index].fetch({ metaFieldGroupId: metaGroup.id, expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns' });
            }
            index++;
            return result;
        }, []);
    }

    closeLists () {
        const length = this.opened.length;
        for (let i = 0; i < length; i++) {
            this.opened[i] = false;
        }
    }

    addMetaFieldGroup () {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-meta-group-add ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()"></forms-settings-meta-group-add>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => {
            this.list.fetch({ expand: 'activeI18n,metaGroupI18ns' }).then(() => {
                this.openAll();
            });
        });
    }

    addMetaField (index, groupId) {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-meta-field-add group-id="vm.groupId" ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()"></forms-settings-meta-field-add>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.groupId = groupId;
            }
        }).then(() => {
            this.openAll();
            this.metaFieldLists[index].fetch({ metaFieldGroupId: groupId, expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns' });
        });
    }

    updateMetaField (index, item, groupId) {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-meta-field-edit ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()" meta-field-group="vm.item"></forms-settings-meta-field-edit>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.item = item;
            }
        }).then(() => {
            this.metaFieldLists[index].fetch({ metaFieldGroupId: groupId, expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns' });
        });
    }

    deleteMetaField (index, id, groupId) {
        this.ModalService.confirm(
            this.$translate.instant('metaField.Are you sure you want to delete this meta field')
            , 'large'
        ).then(() => {
            this.MetaFieldResource.delete({ id }).$promise.then(() => {
                this.metaFieldLists[index].fetch({ metaFieldGroupId: groupId, expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns' });
            }).catch((errors) => {
                this.errors = errors.data.map(error => {
                    return error.message;
                });
                window.scrollTo(0, 0);
            });
        });
    }


    editMetaFieldGroup (index, item) {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-meta-group-edit ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()" meta-field-group="vm.item"></forms-settings-meta-group-edit>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.item = item;
            }
        }).then(() => {
            this.list.fetch({ expand: 'activeI18n,metaGroupI18ns' }).then(() => {
                this.openAll();
            });
        });
    }

    deleteMetaGroup (index, id) {
        this.ModalService.confirm(
            this.$translate.instant('metaField.Are you sure you want to delete this metafield group?')
            , 'large'
        ).then(() => {
            this.MetaFieldGroupResource.delete({ id }).$promise.then(() => {
                this.list.items = this.list.items.filter(item => item.id !== parseInt(id, 10));
                this.metaFieldLists.pop(index);
            }).catch(errors => {
                this.errors = errors.data.map(error => {
                    return error.message;
                });
                window.scrollTo(0, 0);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/meta/list/index.js